module.exports = __webpack_public_path__ + "img/2.dade7b1e.jpg";